import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/store";
import Loader from "../../components/ui/Loader";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import { userLoggedIn } from "../../features/auth/authSlice";
import { redirectToUrl } from "../../utils/utils";

const portalLink = process.env.REACT_APP_PORTAL_URL;

export default function KeycloakSignIn() {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loginAttempted, setLoginAttempted] = useState(false);

  useEffect(() => {
    if (!initialized) return;

    // If already authenticated with valid token
    if (keycloak.authenticated && keycloak.token) {
      // Store token in localStorage and Redux
      const userData = {
        access_token: keycloak.token,
        refresh_token: keycloak.refreshToken,
      };

      localStorage.setItem(AUTH_LOCALSTORAGE_NAME, JSON.stringify(userData));
      dispatch(userLoggedIn({ access_token: keycloak.token }));

      // Navigate to dashboard
      navigate("/admin/dashboard");
      return;
    }

    // If not authenticated and haven't tried login yet
    if (!keycloak.authenticated && !loginAttempted) {
      setLoginAttempted(true);
      localStorage.clear();

      if (portalLink) {
        redirectToUrl(portalLink + "/sign-in");
      } else {
        keycloak.login({ redirectUri: window.location.origin + "/" });
      }
    }
  }, [keycloak, initialized, loginAttempted, navigate, dispatch]);

  return <Loader />;
}
